import React from 'react';
import { ReviewRating } from './ReviewRating';
import { MuchLove } from './MuchLove';

export class ReviewRatingWithMuchLove extends React.Component {
    render() {
        var rating = this.props.rating;
        var muchLove = rating >= 8;
        let ratingString;
        if (muchLove) {
            ratingString =
                <MuchLove
                    doPadLeft={this.props.doPadLeftMuchLove}
                    doUseTextLarge={this.props.doUseTextLarge}
                />;
        } else {
            ratingString =
                <ReviewRating
                    rating={rating}
                    size="x-small"
                />;
        }
        return (
            <div>
                <div>{ratingString}</div>
            </div>
        );
    }
}